/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Product
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Product
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productCategoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof Product
     */
    statusDate?: Date;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'productName': !exists(json, 'product_name') ? undefined : json['product_name'],
        'isAvailable': !exists(json, 'is_available') ? undefined : json['is_available'],
        'productCategoryId': !exists(json, 'product_category_id') ? undefined : json['product_category_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
    };
}

export function ProductToJSON(value?: Product | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'product_name': value.productName,
        'is_available': value.isAvailable,
        'product_category_id': value.productCategoryId,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
    };
}


